export const DRAWER_WIDTH = 260

export const DRAWER_KEYS = {
    DASHBOARD: 'DASHBOARD',
    PLANS: 'PLANS',
    PLAN_GROUPS: 'PLAN_GROUPS',
    APPLICATION_SERVICES: 'APPLICATION_SERVICES',
    ACCESS_KEYS: 'ACCESS_KEYS',
    USERS: 'USERS',
    EXIT: 'EXIT'
}